import PermitField from '../models/PermitField'
import { EMPTY_STRING } from './usefulStrings'

function removeRelatedConditionals(
  fields: PermitField[],
  parentInstanceId: string,
  parentValueIndex: number,
): PermitField[] {
  const fieldsToRemove = fields.filter(
    f =>
      f.parentInstanceId === parentInstanceId &&
      f.parentValueIndex === parentValueIndex,
  )

  let updatedFields = fields

  fieldsToRemove.forEach(field => {
    field.values.forEach((_, idx) => {
      updatedFields = removeRelatedConditionals(
        updatedFields,
        field.instanceId,
        idx,
      )
    })
  })

  return updatedFields.filter(
    f => !fieldsToRemove.some(r => r.instanceId === f.instanceId),
  )
}

function readjustParentValueIndexes(
  fields: PermitField[],
  parentInstanceId: string,
  removedIndex: number,
) {
  const conditionals = fields.filter(
    f =>
      f.parentInstanceId === parentInstanceId &&
      f.parentValueIndex > removedIndex,
  )

  conditionals.forEach(f => (f.parentValueIndex -= 1))
}

export const removeWorkflowConditionals = (
  fields: PermitField[],
  parentInstanceId: string,
  parentValueIndex: number,
  isFullRemoval?: boolean,
): PermitField[] => {
  const updatedFields = removeRelatedConditionals(
    fields,
    parentInstanceId,
    parentValueIndex,
  )

  if (!isFullRemoval) {
    readjustParentValueIndexes(
      updatedFields,
      parentInstanceId,
      parentValueIndex,
    )
  }

  return updatedFields
}

export const getWorkflowFieldKey = (
  fieldId: string,
  parentInstanceId: string | undefined,
  parentValueIndex: number | undefined,
): string => {
  return `${fieldId}|${parentInstanceId ?? EMPTY_STRING}|${
    Number.isFinite(parentValueIndex) ? parentValueIndex : EMPTY_STRING
  }`
}
